import React from 'react'

function ReturnRatioReasonBar() {
    return (
        <div className="flex border-t border-[#EAEAEA] font-urbanist-regular font-medium">
            <h2 className="
                w-[32%] max-[1280px]:w-[29%] max-[1024px]:w-[28%] 
                px-[10px] py-3 
                text-[16px] max-[1152px]:text-[14px] 
                leading-6 
                text-[#121212] 
                whitespace-nowrap 
                overflow-hidden 
                text-ellipsis"
            >
                Item doesn't match the description
            </h2>
            <h2 className="
                w-[17%] max-[1024px]:w-[15.5%] 
                px-[10px] py-3 
                text-[16px] max-[1152px]:text-[14px] 
                leading-6 
                text-[#121212]"
            >
                32%
            </h2>
            <h2 className="
                w-[17%] max-[1280px]:w-[20%] max-[1024px]:w-[21.5%] 
                px-[10px] py-3 
                text-[16px] max-[1152px]:text-[14px] 
                leading-6 
                text-[#121212]"
            >
                8744
            </h2>
            <h2 className="
                w-[17%] max-[1024px]:w-[16.5%] 
                px-[10px] py-3 
                text-[16px] max-[1152px]:text-[14px] 
                leading-6 
                text-[#121212]"
            >
                12
            </h2>
            <h2 className="
                w-[17%] max-[1024px]:w-[18.5%] 
                px-[10px] py-3 
                text-[16px] max-[1152px]:text-[14px] 
                leading-6 
                text-[#121212]"
            >
                2
            </h2>
        </div>
    )
}

export default ReturnRatioReasonBar;
